import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { BackupService } from './backup.service';
import { BackupApiService } from './backup-api.service';
import { DbCleanupService } from './db-cleanup.service';
import { PersonalService } from './personal.service';

@Injectable({
  providedIn: 'root'
})
export class RedirectService {
  constructor(
    private router: Router,
    private backupService: BackupService,
    private backupApiService: BackupApiService,
    private personalService: PersonalService,
    private dbCleanupService: DbCleanupService
  ) {}

  async checkRedirectPath(): Promise<boolean> {
    try {
      const listWithVersions = await firstValueFrom(
        this.backupApiService.getAllBackupListWithVersion()
      );
      const bankingDataResponse = await firstValueFrom(
        this.personalService.loadBankingData()
      );

      const versions = listWithVersions?.data?.backupVersions ?? [];
      if (versions.length) {
        // Удаляем локальные устаревшие записи и проверяем обновления без дополнительного сетевого запроса
        await this.backupService.deleteOutdatedBackups(versions.map(v => v.id));
        if (this.backupService.checkUpdatesFromServerList) {
          await this.backupService.checkUpdatesFromServerList(versions);
        } else {
          // Fallback на старую логику, если метод отсутствует
          await this.backupService.checkUpdates();
        }
      }

      // если список добавленных банковских реквизитов пуст, редиректим на заполнение
      if (!bankingDataResponse?.data?.length) {
        return this.router.navigate(['banking-data'], {
          queryParams: { authPath: true }
        });
      }

      this.dbCleanupService.cleanupDbData();
      return this.router.navigate(['requests']);
    } catch {
      // Пост-авторизационная загрузка (список бэкапов / банковские реквизиты) упала (500/таймаут/обрыв).
      // Токен уже сохранён и сессия поднята, поэтому НЕ оставляем пользователя запертым на /auth без
      // реакции (прежде возвращали false → навигации не было): уводим на безопасный дефолт. Проверку
      // банковских реквизитов он пройдёт при следующем заходе.
      return this.router.navigate(['requests']);
    }
  }
}
